<template>
  <v-flex>
    <slot />
  </v-flex>
</template>
